<template>
<div id="establishments-close-modal">
  <modal v-model="show"
         :backdrop="false"
         :header="false">
    <h3>
      {{ surveillance.establishment.name }}
      <br /><small>Surveillance SPIADI 2019</small>
    </h3>
    <alert type="warning">
      <p>
        <span class="glyphicon glyphicon-alert" aria-hidden="true">
        </span>
        <strong>Rappel !</strong>
      <p>
      <p>
        Une fois la clôture effectuée, la fiche établissement et les
        fiches déjà saisies ne pourront plus être modifiées. Si vous
        souhaitez continuer la surveillance, il sera en revanche
        toujours possible d'ajouter de nouvelles fiches.
      </p>
    </alert>
    <div v-for="t in types"
         :key="`establishments-close-summary-${t}`">
      <h4>
        <span :class="`label label-${t}`">
          {{ allTypes[t].label }}
        </span>
      </h4>
      <div>
        Surveillance du
        <dropdown class="date-picker">
          <btn class="dropdown-toggle" type="warning" size="sm">
            <i class="glyphicon glyphicon-calendar"></i>
            <strong>{{ dateFR[t].start }}</strong>
          </btn>
          <template slot="dropdown">
            <li>
              <date-picker v-model="date[t].start"
                           :clear-btn="false"
                           limit-from="2019-01-01"
                           limit-to="2019-04-01"/>
            </li>
          </template>
        </dropdown>
        au
        <dropdown class="date-picker">
          <btn class="dropdown-toggle" type="primary" size="sm">
            <i class="glyphicon glyphicon-calendar"></i>
            <strong>{{ dateFR[t].end }}</strong>
          </btn>
          <template slot="dropdown">
            <li>
              <date-picker v-model="date[t].end"
                           :clear-btn="false"
                           limit-from="2019-03-31"
                           limit-to="2019-07-01"/>
            </li>
          </template>
        </dropdown>
      </div>
    </div>
    <div class="certification">
      <alert type="info">
        <div class="checkbox">
          <label>
            <input type="checkbox" id="checkbox" v-model="confirm">
            Je certifie avoir saisi et validé toutes les fiches (dont la fiche
            établissement) en concordance avec les dates indiquées ci-dessus.
          </label>
        </div>
      </alert>
      <alert v-if="error != null"
             type="danger">
        <p>
          <span class="glyphicon glyphicon-alert" aria-hidden="true">
          </span>
          <strong>Attention !</strong>
        <p>
        <p>
          {{ error }}
        </p>
      </alert>
      <btn @click="close"
           block
           type="warning" size="lg"
           :disabled="!(closing || confirm)">
        Clôturer la surveillance
      </btn>
    </div>
    <div slot="footer">
      <btn @click="hide" type="default">Annuler</btn>
    </div>
  </modal>
</div>
</template>
<script>
import modules from '@/sui/data/modules'
import moment from 'moment'

export default {
  name: 'establishments-close-modal',
  props: {
    value: {
      type: Boolean,
      required: true
    },

    surveillance: {
      type: Object,
      required: true
    },

    types: {
      type: Array,
      required: true
    }
  },

  data: function () {
    return {
      show: this.value,
      confirm: false,
      closing: false,
      error: null,
      date: {
        bactADI: {
          start: '2019-01-01',
          end: '2019-04-01'
        },
        reaInfADI: {
          start: '2019-01-01',
          end: '2019-04-01'
        },
        reaBactADI: {
          start: '2019-01-01',
          end: '2019-04-01'
        },
        neoInfADI: {
          start: '2019-01-01',
          end: '2019-04-01'
        },
        diaInfADI: {
          start: '2019-01-01',
          end: '2019-04-01'
        }
      }
    }
  },

  computed: {
    allTypes: function () {
      return modules
    },

    dateFR: function () {
      const result = {}

      for (let i in this.date) {
        const d = this.date[i]
        const start = new Date(d.start)
        const end = new Date(d.end)
        result[i] = {
          start: moment(start).format('DD/MM/YYYY'),
          end: moment(end).format('DD/MM/YYYY')
        }
      }
      return result
    }
  },

  methods: {
    hide: function () {
      this.confirm = false
      for (let i in this.date) {
        const d = this.date[i]
        d.start = '2019-01-01'
        d.end = '2019-04-01'
      }

      this.$emit('input', false)
    },

    setError: function () {
      this.error = `Impossible de clôturer la surveillance, merci de
vérifier la cohérence des dates avant de réessaier. Si le problème persiste,
merci de contacter un administrateur en utilisant le formulaire de contact.`
    },
    close: function () {
      this.closing = true
      const vm = this
      const p = {}
      for (let i in this.types) {
        const type = this.types[i]
        const start = new Date(this.date[type].start)
        start.setHours(10)
        const end = new Date(this.date[type].end)
        end.setHours(10)
        p[type] = { start: start, end: end }
      }
      const request = { i: this.surveillance.id, p: p }
      this.$store.dispatch('surveillances/close', request).then(
        (response) => {
          vm.closing = false
          if (response.data.err == null) {
            vm.$notify(
              {
                type: 'success',
                title: 'Surveillance clôturée !',
                content: `Merci d'avoir participé à la surveillance
SPIADI 2019, un e-mail confirmant la clôture de la surveillance de
l'établissement ${this.surveillance.establishment.name} vous a été
envoyé.`,
                duration: 10000
              }
            )
            vm.hide()
          } else {
            vm.setError()
          }
        }
      ).catch(() => {
        vm.closing = false
        vm.setError()
      })
    }
  },

  watch: {
    value: function () {
      this.show = this.value
    }
  }
}
</script>
<style lang="less" scoped>
.glyphicon {
    margin-right: 0.7rem;
}
.certification {
    padding: 2rem 0rem;
}
.date-picker {
    margin-left: 1rem;
    margin-right: 1rem;
}
</style>
